import { render } from "./SectionPromo.vue?vue&type=template&id=eb39e344"
import script from "./SectionPromo.vue?vue&type=script&lang=js"
export * from "./SectionPromo.vue?vue&type=script&lang=js"

import "./SectionPromo.vue?vue&type=style&index=0&id=eb39e344&lang=scss"

import exportComponent from "d:\\_NX_WORK_\\XSET_SITE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__